import { VPagination } from 'vuetify/lib/components/VPagination';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VPagination,_vm._b({staticClass:"pagination",attrs:{"value":_vm.page,"length":_vm.size,"total-visible":7,"color":"primary"},on:{"input":_vm.emitChange}},'v-pagination',_vm.computedLenght,false))}
var staticRenderFns = []

export { render, staticRenderFns }